import React from 'react'
import PropTypes from 'prop-types'

const POPUP_DIMENSIONS = {
  width: 430,
  height: 500
}

const Login = ({ item, isLoggingIn, onLogin, onDone }) => {

  const handleLogin = () => {
    window.open(
      "https://accounts.google.com/Login",
      "",
      `height=${POPUP_DIMENSIONS.height},
      width=${POPUP_DIMENSIONS.width},
      top=${(screen.height - POPUP_DIMENSIONS.height)/2},
      left=${(screen.width - POPUP_DIMENSIONS.width)/2}`
    )
    onLogin()
  }

  const LOGIN_CONFIG = {
    true: {
      text: "Log in window has opened",
      actionText: "Click here when you are logged in",
      action: onDone
    },
    false: {
      text: "You are not logged in to Google",
      actionText: "Log in now",
      action: handleLogin
    }
  }

  const config = LOGIN_CONFIG[isLoggingIn]
  return (
    <div className="google-login-container">
      <div className="image-container" style={{backgroundImage: `url(${item.image.url})`}} >
        <img
          src="http://upload.wikimedia.org/wikipedia/commons/4/4a/Logo_2013_Google.png"
          alt="Google logo image" />
      </div>
      <div className="text-container">
        <h1>{config.text}</h1>
        <a onClick={config.action}>{config.actionText}</a>
      </div>
    </div>
  )
}

Login.propTypes = {
  item: PropTypes.object.isRequired,
  isLoggingIn: PropTypes.bool.isRequired,
  onLogin: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired
}

export default Login